module.exports = __webpack_public_path__ + "static/media/Sec-1_Home_EN_Mobile.4c99dcf5.png";